<script>
  import { onDestroy } from 'svelte';
  import { fetchFeed, fetchNewestFeed } from '../../api/NTB/query';
  import FeedItem from './FeedItem/FeedItem.svelte';
  import Highlights from './Highlight/Highlights.svelte';
  import Icon from '../Icons/Icon.svelte';
  import Spinner from '../Icons/Spinner.svelte';
  export let title;
  export let channel;
  let items = [];
  let filteredItems = [];
  let links;
  let spinner = false;
  let isHighlightedOnly = false;

  $: (title || channel) && fetchFirstLiveFeed();

  const interval = setInterval(() => fetchFreshData(), 20000);

  const fetchFreshData = async () => {
    if (channel) {
      const res = await fetchNewestFeed(
        channel,
        items[0]._updated || items[0]._created
      );
      if (res && res._items.length) {
        replacePrevVersions(res);
        items = res._items
          .filter((e) => !e.deleted && e.published_date)
          .concat(items);
        filterList();
      }
    } else {
      items = [];
      filteredItems = [];
    }
  };

  const replacePrevVersions = (res) => {
    res._items.map((item, index) => {
      if (item._current_version > 1) {
        items.map((i) => {
          if (i._id === item._id) {
            i = item;
            res._items.splice(index, 1);
          }
        });
      }
    });
  };

  const fetchFirstLiveFeed = async () => {
    if (channel) {
      items = [];
      filteredItems = [];
      const res = await fetchFeed(channel);
      items = res._items.filter((e) => !e.deleted && e.published_date);
      filteredItems = res._items.filter((e) => !e.deleted && e.published_date);
      links = res._links;
    } else {
      items = [];
      filteredItems = [];
    }
  };

  const onHighlightSlide = (e) => {
    isHighlightedOnly = e.detail;
    filterList();
  };

  const filterList = () => {
    if (isHighlightedOnly) {
      filteredItems = items.filter((item) => item.lb_highlight);
    } else {
      filteredItems = items;
    }
  };

  const nextPage = async () => {
    spinner = true;
    const res = await fetchFeed(channel, links.next.href);
    let removeDeleted = res._items.filter(
      (e) => !e.deleted && e.published_date
    );
    items = items.concat(removeDeleted);
    filterList();
    links = res._links;
    spinner = false;
  };

  const back = () => {
    const feedContainer = document.getElementsByClassName('feed-app')[0];
    feedContainer.scrollIntoView();
  };

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<style src="feedcontainer.scss">
</style>

{#if items.length}
  <div class="feed-container">
    <section class="feed-items">
      <header class="sub-title">
        {title}
        <Highlights on:highlight={onHighlightSlide} />
      </header>
      {#each filteredItems as item}
        <FeedItem {item} />
      {/each}
    </section>
    {#if spinner}
      <Spinner />
    {/if}
    {#if filteredItems.length}
      <section class="navigation">
        {#if links && links.next}
          <button on:click={nextPage}>
            <Icon type="arrow_down" />
            Se flere</button>
        {/if}
        {#if filteredItems.length > 10}
          <button on:click={back}>
            <Icon type="arrow_down" style="transform: rotate(180deg)" />
            Til toppen</button>
        {/if}
      </section>
    {:else}<span class="no-data">Ingen høydepunkter funnet</span>{/if}
  </div>
{/if}
